var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "root relative",
    class: {
      focused: _vm.focused,
      disabled: _vm.disabled,
      'px-1': !_vm.disabled,
      highlight: _vm.highlight,
      'has-error': _vm.error
    },
    on: {
      "click": _vm.onClick
    }
  }, [!_vm.value ? _c('span', {
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_vm._t("placeholder", function () {
    return [_c('span', {
      staticClass: "grey--text text--lighten-1",
      domProps: {
        "innerHTML": _vm._s(_vm.placeholder || '&nbsp;')
      }
    })];
  })], 2) : _vm._e(), !_vm.$slots.placeholder || _vm.value ? _vm._t("default", function () {
    return [_c('span', {
      ref: "content",
      class: {
        'absolute-fill': !_vm.value
      },
      attrs: {
        "contenteditable": _vm.disabled ? false : 'plaintext-only'
      },
      on: {
        "input": function (e) {
          return _vm.$emit('input', e.target.innerText);
        },
        "focusin": function ($event) {
          _vm.focused = true;
        },
        "focusout": function ($event) {
          _vm.focused = false;
        },
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    })];
  }) : _vm._e(), _vm._t("suffix")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }